document.addEventListener("DOMContentLoaded", () => {
    const aside = document.getElementById("right");
    const footer = document.querySelector("footer");

    if (!aside || !footer) return;

    window.addEventListener("scroll", () => {
        const footerTop = footer.getBoundingClientRect().top;
        const windowHeight = window.innerHeight;

        if (footerTop <= windowHeight) {
            aside.style.display = "none";
        } else {
            aside.style.display = "block";
        }
    });
});
